
export { fetchServerXAuthWithBinaryRole } from "/__w/wiggot-web/wiggot-web/packages/utils/src/fetch-server.ts"